import {mapGetters} from 'vuex';
import {
    getMenuLists
} from 'src/api/common.api.js';
import serve from 'src/common/js/serve.js';

export default {
    data () {
        return {
            menuList: [] // 菜单
        };
    },
    computed: {
        onRoutes () {
            let that = this;

            return that.$route.path;
        },
        ...mapGetters([
            'getMenu'
        ])
    }
};



// WEBPACK FOOTER //
// ./src/views/common/siderbar/siderbar.js